<template>
    <div>
        <div class="container modal-term p-0">
            <!-- <h1 class="title-term mb-0">นโยบายความเป็นส่วนตัว</h1> -->
            <div class="overflow-scroll-gradient">
                <div
                    class="overflow-scroll-gradient__scroller"
                    v-html="pdpaContent"
                ></div>
            </div>
        </div>

        <modal-master :controller="modalController"></modal-master>
    </div>
</template>
<script>
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
//service
import BzbsPDPA from "@/core/PDPA/service/BzbsPDPA.js";

export default {
    name: "Terms",
    components: {},
    mixins: [LocaleMixin, ErrorApiMixin, ModalMixin],
    data: function() {
        return {
            pdpaContent: "",
            pdpaVersion: 0,

            modalController: null
        };
    },
    created: function() {
        this.setupTerms();

        this.modalController.setAlertModal(this.alertModal);
    },
    methods: {
        setupTerms: async function() {
            // await this.apiGetTermsVersion();
            await this.apiGetTermsContent();
        },

        apiGetTermsVersion() {
            return new Promise((resolve, reject) => {
                BzbsPDPA.apiGetPDPAVersion().subscribe(
                    data => {
                        this.pdpaVersion = data.privacy.current_version;
                        resolve(data);
                    },
                    err => {
                        this.errorResponse(err);
                        reject(err);
                    }
                );
            });
        },
        apiGetTermsContent: function() {
            return new Promise((resolve, reject) => {
                BzbsPDPA.apiGetPDPAContent(
                    "privacy",
                    this.pdpaVersion,
                    "1054" + ".txt"
                ).subscribe(
                    data => {
                        this.pdpaContent = data;
                        resolve(data);
                    },
                    err => {
                        this.errorResponse(err);
                        reject(err);
                    }
                );
            });
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/_mixin.scss";
.overflow-scroll-gradient {
    position: relative;
}
.overflow-scroll-gradient__scroller {
    overflow-y: scroll;
    height: 700px;
    @include breakpoint-max(385) {
        height: 500px;
    }
    padding: 15px 0;
    line-height: 24px;
    text-align: left;
    color: white;
    font-size: 16px;
    padding-right: 10px;
}
</style>
